// Components==============
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { FilterType } from 'typings';
import { FilterContext } from '../../FilterMenu';
import './Search.module.scss';
// =========================

export default function Search({ value, id }: { value: string; id: number }) {
  const { setFilterValues, filterValues } = useContext(FilterContext);

  const translate = useTranslate();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const newValue = filterValues.map((test) =>
      test.id === id ? { ...test, value: e.target.value } : test
    ) as FilterType[];

    setFilterValues(newValue);
  }

  return (
    <input
      value={value}
      onChange={handleChange}
      type="text"
      styleName="input"
      placeholder={translate('filters.search-bar.search-placeholder') as string}
    />
  );
}
